import { CreditCardOutlineIcon } from './CreditCardOutlineIcon';

/**
 * author: Google
 * id A121DBBB-C9E6-4534-AA7B-F59496787BD2
 * name credit-card-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-outline.svg
 * tags
 * - Shopping 
 * - Banking 
 * - Currency 
 */
export const PaymentIcon = CreditCardOutlineIcon;
export default PaymentIcon